import functions from "../functions/functions";

class Add2CartControls{
    constructor(){

    }
    // -------------------------------------
    // Обработчик кнопок для смены ед. измерения - в карточке, в листинге, везде
    // -------------------------------------
    handleUnitLink($unitLink, dontShowMessage) {
        dontShowMessage = (typeof dontShowMessage !== 'undefined') ? dontShowMessage : false;

        let $productItem = $unitLink.closest('.js-product');
        let $unit = $productItem.find('[name="unit"]');
        let val = $unitLink.attr('data-val');

        $productItem.attr('data-last-unit-value', this.getActiveUnitValue($productItem).value);
        $productItem.find('.js-product__volume-tab.active').removeClass('active');
        $unitLink.addClass('active');
        $unit.val(val);

        // ВАЖНО! Перерасчет цены и кол-ва товара должен быть ПОСЛЕ changeUnit, потому что на это событие вешается перерасчет step и кол-ва товара (на самом деле уже не особо важно, т.к. step теперь не используется)
        // Вызываем событие о том, что у товара изменилась ед. измерения
        $productItem.trigger('changeUnit');

        // Обработчик кнопки на странице товара для смены ед. измерения
        this.calcPrice($productItem);

        // Пересчитываем кол-во товара в корзине
        this.changeCountItemInCart($productItem, true, null, dontShowMessage);
    }

    /**
     * Изменение кол-ва товара.
     */
    changeCountItemInCart($productItem, forbidZero, $target, dontShowMessage) {
        dontShowMessage = (typeof dontShowMessage !== 'undefined') ? dontShowMessage : false;
        forbidZero = typeof forbidZero !== 'undefined' ? forbidZero : false;
        $target = typeof $target !== 'undefined' ? $target : null;

        // Товар в корзине?
        let inCart = false;
        // Счетчик с кол-вом товара
        let $inputAmount;

        // Все формы чанка
        let $forms = functions.getActiveForm($productItem);
        // Системные формы, которые нужны для управления корзиной
        let $systemForm = $forms['system'];
        if ($productItem.hasClass('js-product-in-cart')) {
            inCart = true;
        }

        if ($target === null) {
            // Получаем input с количеством товара
            $inputAmount = $forms['action'];
            // На странице кровли с перелинковуой 2 формы - одна для ПК, другая для мобилок. Возможно, в будущем еще где-то будет также. Получаем видимую, она будет главной
            if ($inputAmount.length > 1) {
                $forms['action'].each(function (i, e) {
                    if ($(e).is(':visible')) {
                        $inputAmount = $(e);
                    }
                });
            }
            $inputAmount = $inputAmount.find('.custom-counter__amount');
        } else {
            $inputAmount = $target;
        }

        // Получаем новое кол-во товара, которое будет отображено на счетчике
        let val = $inputAmount.val();

        // Устанавливаем кол-во товара всем input'ам данного товара. Дело в том, что input'ов на странице может быть несколько (например, на кровле в карточке товара для мобилок одна форма, для ПК - другая. И они должны быть синхронизированы)
        $forms['action'].each(function (i, e) {
            $(e).find('.custom-counter__amount').each(function (i, e) {
                let valTmp = val;
                let $checkedAmount = $(e);

                // Коэффициент проверяемого счетчика
                let koeff1 = $checkedAmount.attr('data-koeff');
                // Коэффициент изменяемого счетчика
                let koeff2 = $inputAmount.attr('data-koeff');

                // Коэфициент есть у проверяемого счетчика, но нет у изменяемого
                let cond1 = typeof koeff1 !== 'undefined' && typeof koeff2 === 'undefined';
                // Коэфициент есть у изменяемого счетчика, но нет у проверяемого
                let cond2 = typeof koeff1 === 'undefined' && typeof koeff2 !== 'undefined';

                // Если ни одно из условий в switch не сработало, значит, коэфициента нет ни у проверяемого, ни у изменяемого счетчиков
                switch (true) {
                    // Коэфициент есть у проверяемого счетчика, но нет у изменяемого
                    case (cond1):
                        valTmp = koeff1 * valTmp;
                        break;
                    // Коэфициент есть у изменяемого счетчика, но нет у проверяемого
                    case (cond2):
                        valTmp = valTmp / koeff2;
                        break;
                }

                if ($productItem.find('.custom-counter_type_fractional').length) {
                    valTmp = Number(valTmp).toFixed(2);
                } else {
                    valTmp = Math.ceil(valTmp);
                }

                if (!$checkedAmount.is($inputAmount)) {
                    if (!$checkedAmount.parent().hasClass('custom-counter_type_fractional')) {
                        valTmp = Math.ceil(valTmp);
                    }

                    // parseFloat нужен, чтобы удалить ненужные нули в конце числа
                    valTmp = parseFloat(valTmp);
                    $checkedAmount.val(valTmp);
                }

                if (cond2) {
                    val = valTmp;
                }
            });
        });

        // Устанавливаем то количество, которое будет добавлено в корзину
        let count = this.getItemCount($productItem, val);
        if (forbidZero && count === 0) {
            count = 1;
        }

        $systemForm.find('[name="count"]').val(count);

        // Если товар в корзине, то...
        if (inCart) {
            // Если не нужно показывать сообщение о результате отправки формы, то...
            let $dontShowMessageInput;
            if (dontShowMessage) {
                $dontShowMessageInput = $('<input name="dont_show_message" value="1">').appendTo($systemForm);
            }

            // Отправка
            $systemForm.find('[type="submit"]')[0].click();

            // Если кол-во равно нулю
            if (count === 0) {
                let $elemsAdd = $productItem.find('.js-product__controls_action_add');
                // refreshInput нужен, чтобы inputFilter запомнил текущее значение. И потом, если пользователь установит меньше минимального, подставится 1
                $elemsAdd.find('[name="count"]').each(function (i, e) {
                    let $e = $(e);
                    let newVal = 1;
                    if ($e.attr('data-koeff')) {
                        newVal = $e.attr('data-koeff') * newVal;
                    }
                    $e.val(newVal).trigger('refreshInput');
                });
                // Удаление класса, что товар этой карточки в корзине
                $productItem.removeClass('js-product-in-cart');
            }

            if (typeof $dontShowMessageInput !== 'undefined' && $dontShowMessageInput.length) {
                $dontShowMessageInput.remove();
            }
        }

        $productItem.trigger('changeAmount');
    }

    /**
     * Получить кол-во товара, которое будет добавлено в корзину (зависит от выбранной единицы измерения).
     */
    getItemCount($productItem, count) {
        let unitVal = this.getActiveUnitValue($productItem);
        count = parseFloat(count);
        // Получившееся кол-во
        //count = 1 / unitVal.unit * count;
        count = Math.round((1 / unitVal.value * count) * 100)/100; //.toFixed(2);
        

        if ($productItem.find('.custom-counter_type_fractional').length) {
            count = Number((count).toFixed(2));
        } else {
            if ($('body.kirpich-m').length) {
                count = Math.round(count);
            } else if($('body.krovelnyjstroymarket').length) {
                count = count;
            } else {
                count = Math.ceil(count);
            }
        }

        // Результат
        return count;
    }

    /**
     * Смена цены в соответствии с ед. измерения.
     */
    calcPrice($productItem) {
        let active_unit = this.getActiveUnitValue($productItem)
        let unitVal = active_unit.value;
        let selectors = [];

        selectors.push('.js-product__price');
        if ($productItem.hasClass('js-product_with-discount')) {
            selectors.push('.js-product__old-price-val');
        }

        selectors.forEach(function (selector) {
            let $elem = $productItem.find(selector);

            if ($elem.length) {
                let value = parseFloat($elem.attr('data-default').replace(/\s/g, ''));
                if (isNaN(value)) {
                    value = 0;
                }

                // Для некоторых значений не нуэжно ничего расчитывать, с бэка уже есть правльное значение
                if($('body.bonolit').length && (active_unit.unit == 12 || active_unit.unit == 6)){
                    value = unitVal
                }else{
                    value = Math.round((1 / unitVal * value)*100)/100;//.toFixed(2); //Отбрасывыание части дроби для предотвращения ошибок округления
                }

                if ($('body.kirpich-m').length) {
                    value = Math.round(value);
                } else {
                    value = Math.ceil(value);
                }

                value = Number((value).toFixed(2));                
                value = functions.numberWithSpaces(value);
                $elem.text(value);
            }
        });
    }

    /*
        Переводит юниты единиц измерения в значения. Юниты нужны, чтобы найти имя атрибута, из которого берется значение.
        unit - юнит, по которому выбирается атрибут
        Возвращает значение атрибута или 1 если нет юнита
    */
    getValueFromUnit(unit, $productItem){
        // Все единицы измерения
        const unitValues = {
            '1': 1,
            '2': $productItem.attr('data-m2'),
            '3': $productItem.attr('data-m3'),
            '4': $productItem.attr('data-pm'),
            '5': $productItem.attr('data-list'),
            '6': $productItem.attr('data-thing'),
            '7': $productItem.attr('data-pilomat_thing'),
            '8': $productItem.attr('data-k_m2seam'),
            '9': $productItem.attr('data-k_m3seam'),
            '10': $productItem.attr('data-meter'),
            '11': $productItem.attr('data-upk'),
            '12': $productItem.attr('data-pdn'),
        };
        let result = parseFloat(unitValues[unit]);
        if(isNaN(result)){
            return 1;
        }
        return result;
    }

    /**
     * Получить значение активного unit
     */
    getActiveUnitValue($productItem) {
        /*
        // Все единицы измерения
        let unitValues = {
            '1': 1,
            '2': $productItem.attr('data-m2'),
            '3': $productItem.attr('data-m3'),
            '4': $productItem.attr('data-pm'),
            '5': $productItem.attr('data-list'),
            '6': $productItem.attr('data-thing'),
            '7': $productItem.attr('data-pilomat_thing'),
            '8': $productItem.attr('data-k_m2seam'),
            '9': $productItem.attr('data-k_m3seam'),
            '10': $productItem.attr('data-meter'),
            '11': $productItem.attr('data-upk'),
            '12': $productItem.attr('data-pdn'),
        };

        // Обработка кол-ва единиц измерения
        for (let key in unitValues) {
            unitValues[key] = parseFloat(unitValues[key]);
            if (isNaN(unitValues[key])) {
                unitValues[key] = 0;
            }
        }
        */
        let unit = $productItem.find('*[name="unit"]').val();
        if (typeof unit === 'undefined') {
            unit = '1';
        }

        return {
            value: this.getValueFromUnit(unit, $productItem),//unitValues[unit],
            unit: unit
        };
    }


    /**
     * Конвертация кол-ва товара в корзине при смене единиц изменения.
     */
    setStepAndAmount($item, dontChangeAmount) {
        dontChangeAmount = (typeof dontChangeAmount !== 'undefined') ? dontChangeAmount : false;

        // ---------------------------------------------
        // Определяем основные переменные
        // ---------------------------------------------
        // Текущий шаг
        let step = 1;

        // Поле в текущей форме
        let $activeFormInput = functions.getActiveForm($item)['action'].find('.custom-counter__amount');

        // Значение активной ед. измерения
        let unitVal = this.getActiveUnitValue($item).value;

        // ---------------------------------------------
        // Устанавливаем новый шаг и новое число (если шаг изменился)
        // ---------------------------------------------
        // Получаем коэффициент. Пока что он задан только у кирпичей. Он нам нужен для установки нового шага
        // let coeff = parseFloat($item.attr('data-coefficient'));
        let coeff;
        if (isNaN(coeff)) {
            coeff = 0;
        }

        // Получаем step
        if (coeff === 0) {
            step = 1;
        } else {
            if (unitVal === 1) {
                // Если это 1 (штуки), то умножаем коэффициент на активную ед. измерения
                step = coeff * unitVal;
            } else {
                // Если это что-то другое, то формула другая. Нужно разделить коэффициент на активную ед. измерения и округлить в большую сторону
                step = Math.ceil(coeff / unitVal);
            }
        }

        // Получаем новое количество товара
        let lastUnitValue = $item.attr('data-last-unit-value');
        let newVal = $activeFormInput.val();
        if (typeof lastUnitValue !== 'undefined') {
            // Если мы с штук перешли на другую ед. измерения
            if (lastUnitValue == 1) {
                newVal = newVal * unitVal;
            } else {
                // Если мы НЕ СО ШТУК перешли на любую другую единицу измерения
                newVal = Math.round((newVal / lastUnitValue * unitVal)*100)/100; //.toFixed(2); //Нужно отбросить часть дроби, чтобы избежать ошибок округления
            }
        } else {
            // Если мы не переходили ни с каких единиц измерения - просто произошла загрузка страницы
            newVal = newVal * step;
        }

        // Округляем новое значение в большую сторону
        newVal = Math.ceil(newVal);

        // Пересчитываем кол-во товара с учетом step
        // newVal = functions.getCorrectValueToCounter(step, newVal);

        // Устанавливаем новый шаг
        // $item.attr('data-step', step);

        // Устанавливаем новое количество
        if (!dontChangeAmount) {
            $activeFormInput.val(newVal);
        }
    }

    /**
     * Инициализация стилизованного счетчика и стилизованного списка.
     */
    initStyledCounter() {
        const host = this;
        $('.not-init.js-product, .cart-item').each(function () {
            // Основные переменные
            let $item = $(this);
            let $counterInput = $item.find('.custom-counter__amount');

            // Инициализируем стилизованный список для смены единиц измерения
            // let $select = $item.find('select.custom-select');
            // $select.euv_custom_select();
            // $select.on('beforeChange.euv_custom_select', function () {
            //     $item.attr('data-last-unit-value', getActiveUnitValue($item));
            // });

            if (!$item.hasClass('cart-table__table-row_type_product')) {
                // Вешаем обработчик на смену единицы измерения - менять шаг и кол-во
                $item.on('changeUnit', function (e) {
                    host.setStepAndAmount($item, !$item.hasClass('js-product-in-cart'));
                });
                // Устанавливаем шаг и кол-во
                host.setStepAndAmount($item, true);
            }

            // Инициализируем фильтры для счетчика
            $counterInput.each(function () {
                let filter;
                const $this = $(this);
                const minVal = parseFloat($this.attr('data-min'));

                // Фильтр для изменения значения
                let regexp = /(^$)|(^(0|[1-9][0-9]{0,})$)/;
                if ($this.closest('.custom-counter_type_fractional').length) {
                    regexp = /(^$)|(^((0|[1-9][0-9]{0,})(\.[0-9]{0,2}){0,1})$)/;
                }
                filter = function (value) {
                    let floatVal = parseFloat(value);
                    let condition = !isNaN(floatVal) && regexp.test(value);

                    if (!isNaN(minVal)) {
                        condition = condition && (floatVal >= minVal);
                    }
                    return condition;
                };

                // Фильтр для изменения значения
                $this.inputFilter(filter);

                // Фильтр для ввода (input) значения
                $this.inputFilter(function (value) {
                    return regexp.test(value);
                }, {'event': 'input'});
            });

            // Обработчик кнопок стилизованного счетчкика
            $item.find('.custom-counter__btn').on('click', function (e) {
                e.preventDefault();

                // Основные переменные
                let $this = $(this);
                let $counter = $this.closest('.custom-counter');
                let $inputValue = $counter.find('.custom-counter__amount');
                let step = 1;
                if ($inputValue.hasClass('custom-counter_type_fractional')){
                    step = 0.01;
                }
                // Установка val
                let val = parseFloat($inputValue.val());
                //val = Math.floor(val / step);
                switch (true) {
                    case $this.hasClass('custom-counter__btn_dir_less'):
                        val -= step;
                        break;
                    case $this.hasClass('custom-counter__btn_dir_more'):
                        val += step;
                        break;
                }
                val = Math.round(val*100)/100; // Для избежания ошибок представления чисел
                //console.log("val * step:" + val);

                $inputValue.val(val);

                // При щелчке по кнопкам на странице корзины и так вызывается change, поэтому повторно его вызывать здесь не надо. Я бегло посмотрел файл плагина, чтобы удалить его оттуда и убрать эти строки. Но ничего там не нашел. По-хорошему надо подправить этот момент в файле плагина. Эти строки тут выглядят как костыль
                if (!$inputValue.closest('.ms2_form').length) {
                    $inputValue.trigger('change');
                }

                // Если кнопка находится в карточке товара корзины, то отправляем форму (кликаем по кнопке для отправки формы)
                $this.closest('.cart-item').find('.btn-sm').click();
            });

            // Удаляем у чанка класс о том, что чанк еще не инициализирован
            $item.removeClass('not-init');
        });
    }

    bindHandlers(){
        
        const host = this;

        // -------------------------------------
        // Стилизованный счетчик и стилизованный список
        // -------------------------------------
        this.initStyledCounter();

        // -------------------------------------
        // Обработчик счетчика на товарах - в карточке, в листинге, везде
        // -------------------------------------
        $(document).on('change', '.js-product .custom-counter__amount', function (e) {
            e.preventDefault();
            host.changeCountItemInCart($(this).closest('.js-product'), false, $(this));
        });

        // -------------------------------------
        // Обработчик кнопки для добавления товара в корзину - в карточке, в листинге, везде
        // -------------------------------------
        $(document).on('click', '.js-product .js-product__to-cart', function (e) {
            e.preventDefault();

            // Основные переменные
            let $this = $(this);
            let $productItem = $this.closest('.js-product');
            let $formAdd = $productItem.find('.js-product__form-add');
            let $formChange = $productItem.find('.js-product__controls_action_change');
            let $closestFormAdd = $(this).closest('.js-product__controls_action_add');
            let purposes = {};

            // Обновление input'ов в форме для изменения кол-ва товара
            /*
            После добавления товара к узлу добавляется класс, который скрывает форму для добавления и показывает форму для изменения кол-ва товара. В этой форме input'ы имеют неправильное значение, нужно обновить его в соответствии с тем, которое указал пользователь при добавлении товара в корзину.
            Но проблема в том, что input'ов может быть несколько: один для штук, другой для м2 (так в карточке с перелинковкой для фанеры). И в них должны быть разные значения (взаимо-сконвертированные). Для этого им указывается атрибут data-purpose, значения input'ов заносятся в массив, где ключ - это значение данного атрибута.
            Если же input всего один, то массив с data-purpose будет пустым. Таким образом, сначала проверяем массив с data-purpose. Если он пустой, то просто копируем значение.
            */
            // Получение кол-ва
            let countRaw = $closestFormAdd.find('.custom-counter__amount').val();
            let count = host.getItemCount($productItem, countRaw);

            $closestFormAdd.find('.custom-counter__amount').each(function (i, e) {
                let $e = $(e);
                let key = $e.attr('data-purpose');
                if (typeof key !== 'undefined') {
                    purposes[key] = $e.val();
                }
            });

            // Установка кол-ва в пользовательский счетчик для изменения кол-ва
            // Цикл для input'ов нужен, т.к. может быть 2 счетчика для изменения кол-ва. Первый - для ПК, второй - для мобилок. Так, например, в карточке с перелинковкой для кровли
            if (Object.keys(purposes).length) {
                for (let key in purposes) {
                    $formChange.find('.custom-counter__amount[data-purpose="' + key + '"]').each(function (i, e) {
                        $(e).val(purposes[key]);
                        e["oldValue-change"] = purposes[key];
                        e["lastValue"] = purposes[key];
                    });
                }
            } else {
                $formChange.find('.custom-counter__amount').each(function (i, e) {
                    $(e).val(countRaw);
                    e["oldValue-change"] = count;
                    e["lastValue"] = count;
                });
            }

            // В скрытые поля
            $formAdd.find('[name="count"]').val(count);
            $('.js-product__form-change [name="count"]').val(count);

            // Отправка скрытой формы для добавления товара в корзину
            $formAdd.find('[type="submit"]')[0].click();
            // Добавление класса, что товар этой карточки в корзине
            $productItem.addClass('js-product-in-cart');
        });

        // -------------------------------------
        // Обработчик списка для смены ед. измерения - в карточке, в листинге, везде
        // -------------------------------------
        $(document).on('change', 'select.js-product__units-select', function (e) {
            e.preventDefault();
            let $productItem = $(this).closest('.js-product');

            // Вызываем событие о том, что у товара изменилась ед. измерения
            $productItem.trigger('changeUnit');

            // ВАЖНО! Перерасчет цены и кол-ва товара должен быть ПОСЛЕ changeUnit, потому что на это событие вешается перерасчет step и кол-ва товара
            // Меняем цену
            host.calcPrice($productItem);
            // Пересчитываем кол-во товара в корзине
            host.changeCountItemInCart($productItem, true);
        });

        $(document).on('click click_without_message', '.js-product__volume-tab', function (event) {
            event.preventDefault();
            event.stopPropagation();
            const $this = $(this);
            if ($this.hasClass('active')) {
                return;
            }
            const val = $this.attr('data-val');

            $('.js-product__volume-tab[data-val="' + val + '"]').each(function (i, e) {
                host.handleUnitLink($(e), event.type == 'click_without_message' || i > 0);
            });
        });


    }

}

export default Add2CartControls;